import { render, staticRenderFns } from "./Movimiento.vue?vue&type=template&id=2c17bf0d&"
import script from "./Movimiento.vue?vue&type=script&lang=ts&"
export * from "./Movimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports